'use strict';

var _tslib = require('./_virtual/_tslib.js');
var jss = require('jss');
var sortCSSmq = require('sort-css-media-queries');

function _interopDefaultLegacy(e) {
	return e && typeof e === 'object' && 'default' in e ? e : { default: e };
}

var sortCSSmq__default = /*#__PURE__*/ _interopDefaultLegacy(sortCSSmq);

function isPlainObject(sample) {
	return (
		sample !== null && typeof sample === 'object' && Array.isArray(sample) === false
	);
}
var UN_QUERIED = '__UN_QUERIED';
function recursiveInnerAndGetQueries(pluginOptions, rules) {
	var queries = {
		groups: {},
		groupsSortNames: []
	};
	for (var index = 0; index < rules.length; index++) {
		var rule = rules[index];
		var query =
			rule.type === 'conditional' && typeof rule.query === 'string'
				? rule.query
				: UN_QUERIED;
		if (!queries.groups.hasOwnProperty(query)) {
			queries.groupsSortNames.push(query);
			queries.groups[query] = [];
		}
		queries.groups[query].push(index);
		// eslint-disable-next-line @typescript-eslint/no-use-before-define
		recursive(pluginOptions, rule);
	}
	queries.groupsSortNames.sort(function (a, b) {
		var aWeight = a === UN_QUERIED ? 0 : a.length;
		var bWeight = b === UN_QUERIED ? 0 : b.length;
		if (aWeight > 0 && bWeight > 0) {
			if (pluginOptions.desktopFirst) {
				return sortCSSmq__default['default'].desktopFirst(a, b);
			} else {
				return sortCSSmq__default['default'](a, b);
			}
		} else {
			return aWeight - bWeight;
		}
	});
	return queries;
}
function recursive(pluginOptions, data) {
	if (isPlainObject(data) && data.rules instanceof jss.RuleList) {
		data.rules.toString = function (options) {
			if (options === void 0) {
				options = {};
			}
			var str = '';
			var sheet = this.options.sheet;
			var link = sheet ? sheet.options.link : false;
			var _a = recursiveInnerAndGetQueries(pluginOptions, this.index),
				groups = _a.groups,
				groupsSortNames = _a.groupsSortNames;
			for (var i = 0; i < groupsSortNames.length; i++) {
				var groupName = groupsSortNames[i];
				var group = groups[groupsSortNames[i]];
				if (groupName !== UN_QUERIED && pluginOptions.combineMediaQueries) {
					str += '\n' + groupName + ' {';
					for (var i_1 = 0; i_1 < group.length; i_1++) {
						var rule = this.index[group[i_1]];
						var css = rule.rules.toString(
							_tslib.__assign(_tslib.__assign({}, options), {
								indent: (options.indent || 0) + 1
							})
						);
						if (!css && !link) continue;
						if (str) str += '\n';
						str += css;
					}
					str += '\n}\n';
				} else {
					for (var i_2 = 0; i_2 < group.length; i_2++) {
						var rule = this.index[group[i_2]];
						var css = rule.toString(options);
						if (!css && !link) continue;
						if (str) str += '\n';
						str += css;
					}
				}
			}
			return str;
		};
	}
}
function jssCombineAndSortMQ(options) {
	if (options === void 0) {
		options = {};
	}
	return {
		onProcessSheet: function (sheet) {
			recursive(options, sheet);
		}
	};
}

module.exports = jssCombineAndSortMQ;
